import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar.js';
import Header from '../Header.js';
import Footer from '../Footer.js';
import { Box } from '@mui/material';
import { useAuth } from '../../context/AuthContext.js';

import SignInComponent from '../signIn/SignIn.js';
import NoRole from '../signIn/NoRole.js';

function Layout({ children }) {
  const userEmail = "usuario@example.com";
  const { user } = useAuth();

  if (user && user?.isAdmin === null) {
    return (<>
      <NoRole />
    </>
    );
  }

  if (!user) {
    return (<>
      <SignInComponent />
    </>
    );
  }

  return (
    <Box display="flex">
      {/*<GoogleOneTapLogin />*/}
      <Sidebar />
      <Box flexGrow={1} padding={"24px"}>
        <Header email={userEmail} />
        <Box p={3}>{children}</Box>
        <Footer />
        <Outlet />
      </Box>
    </Box>
  );
}

export default Layout;
